import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import BrandNav from "../components/BrandNav";
import { api } from "../lib/api";
import { BANDS } from "../lib/palette";
import { extractError } from "../lib/format";
import { Check } from "lucide-react";

export default function PickBand() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [busy, setBusy] = useState("");

  const pick = async (bandId) => {
    setBusy(bandId);
    try {
      await api.post("/enrollments/select-age-band", { age_band: bandId });
      toast.success("You're in — trial enrollment created.");

      // Auto-continue to checkout if the user came from a Buy button
      const nextAction = params.get("next");
      const tierFromUrl = params.get("tier");
      let pending = tierFromUrl;
      if (!pending) {
        try { pending = sessionStorage.getItem("ftg_pending_tier") || ""; } catch { /* ignore */ }
      }
      if ((nextAction === "checkout" || pending) && pending) {
        try { sessionStorage.removeItem("ftg_pending_tier"); } catch { /* ignore */ }
        try {
          const { data } = await api.post("/checkout/session", {
            tier_code: pending, age_band: bandId, origin_url: window.location.origin,
          });
          window.location.href = data.checkout_url;
          return;
        } catch (e) {
          toast.error(extractError(e, "Could not open checkout. Returning to dashboard."));
        }
      }
      nav("/dashboard", { replace: true });
    } catch (e) {
      toast.error(extractError(e, "Could not enroll."));
      setBusy("");
    }
  };

  return (
    <div data-testid="pick-band-page">
      <BrandNav />
      <main className="ftg-shell ftg-page">
        <h1 className="ftg-section-title" data-testid="pick-band-title">Choose your child&apos;s age band</h1>
        <p className="ftg-section-sub">
          {"Your free preview unlocks Term 1 · Week 1 · Lessons 1 & 2 for the band you pick. You can change bands later if it isn't quite right."}
        </p>
        <div className="ftg-bands__grid">
          {BANDS.map(({ id, label, tagline, gradient, Icon, accent }) => (
            <button
              key={id}
              onClick={() => pick(id)}
              disabled={busy && busy !== id}
              className="ftg-band-card"
              style={{
                background: `linear-gradient(140deg, ${gradient[0]} 0%, ${gradient[1]} 100%)`,
                border: "none",
                cursor: "pointer",
                textAlign: "left",
                fontFamily: "inherit",
              }}
              data-testid={`pick-band-${id}`}
            >
              <div>
                <span className="ftg-band-card__icon" style={{ color: accent }}>
                  <Icon size={22} />
                </span>
                <h3 className="ftg-band-card__label">{label}</h3>
                <p className="ftg-band-card__tag">{tagline}</p>
              </div>
              <div className="ftg-band-card__count">
                {busy === id ? "Enrolling…" : (
                  <>
                    <Check size={14} style={{ display: "inline", verticalAlign: "-2px" }} /> Start free
                  </>
                )}
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
